<template>
  <div class="modOrderRecord">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0">
        <div class="col-12 px-0">
          <b-row class="mx-0 mb-3">
            <b-col cols="1"> </b-col>

            <b-col cols="10">
              <b-col
                cols="12"
                class="p-0 m-0 mt-4"
                style="font-size: 1.75rem; color: #000000"
              >
                <span class="m-auto">修改完工回報</span>
              </b-col>

              <div class="container" style="margin-top: 2rem">
                <div class="col-12 row text-left">
                  <div class="mr-2" style="width: 9rem">
                    <p class style="margin-bottom: 0.625rem">
                      派工單號
                    </p>
                    <b-form-input
                      style="
                              max-width: 9rem;
                              height: 2.375rem;
                              line-height: 1.375rem;
                              font-size: 0.875rem;
                              border: 2px solid rgb(255, 255, 255);
                              box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
                              color: rgb(95, 95, 95);
                            "
                      v-model="workID"
                    ></b-form-input>
                  </div>
                  <div class="mr-2" style="width: 9rem">
                    <p class style="margin-bottom: 0.625rem">製程</p>
                    <b-form-select
                      v-model="processSelected"
                      :options="orgProcessOption"
                      class=""
                      style="
                        max-width: 9rem;
                        height: 2.375rem;
                        line-height: 1.375rem;
                        font-size: 0.875rem;
                        border: 2px solid rgb(255, 255, 255);
                        box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 3px 0px;
                        color: rgb(95, 95, 95);
                      "
                    >
                      <template #first>
                        <b-form-select-option :value="null" disabled
                          >-- 選擇製程 --</b-form-select-option
                        >
                      </template>
                    </b-form-select>
                  </div>
                  <div class="mr-2" style="width: 4.25rem">
                    <b-button
                      class="p-0"
                      @click="queryFoolproof"
                      style="
                        margin-top: 38px;
                        background-color: #4b8c80;
                        width: 4.25rem;
                        height: 2rem;
                        font-size: 1.125rem;
                      "
                      >查詢</b-button
                    >
                  </div>
                </div>
              </div>

              <b-col cols="12" class="text-left mx-0">
                <template v-if="sourceData.length != 0">
                  <div class="d-flex justify-content-end mb-3">
                    <div
                      class="py-1 px-2"
                      style="background: #c8c9ca;min-width: max-content;"
                    >
                      <span>異動人員:{{ changeUserName }}</span>
                    </div>
                  </div>

                  <commonWorkorderTable :workorderItem="workorderItem" />

                  <div class="my-auto">
                    <b-button
                      v-for="(sourceDataItem, index) in sourceData"
                      :key="index"
                      class="mr-2 records-button"
                      :class="{ active: userSelectCode == index }"
                      @click="userSelectCode = index"
                      style="margin-bottom: .75rem;"
                    >
                      {{ index + 1 }}
                    </b-button>
                  </div>

                  <sourceRecord
                    :userSelectCode="userSelectCode"
                    :workID="workorderItem[0].work_code"
                    :processID="processID"
                    :sourceData="modStatus ? modData : sourceData"
                    :modStatus="modStatus"
                  />

                  <div class="text-right">
                    <template v-if="!modStatus">
                      <button
                        type="button"
                        class="btn p-0"
                        style="color: #fff;background-color: #4b8c80; width: 6rem; height: 2rem; font-size: 1.125rem;"
                        @click="updateRecord"
                      >
                        進行修改
                      </button>
                    </template>
                    <template v-else>
                      <button
                        type="button"
                        class="btn p-0"
                        style="color: #fff;background-color: #4b8c80; width: 6rem; height: 2rem; font-size: 1.125rem;"
                        @click="updateRecord"
                      >
                        取消修改
                      </button>
                      <button
                        type="button"
                        class="btn p-0"
                        style="color: #fff;background-color: #4b8c80; width: 6rem; height: 2rem; font-size: 1.125rem;"
                        @click="checkUpdate"
                      >
                        確認修改
                      </button>
                    </template>
                  </div>
                </template>
              </b-col>
            </b-col>

            <b-col cols="1"> </b-col>
          </b-row>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import commonWorkorderTable from "@/components/orderManagement/table/commonWorkorderTable.vue";
import sourceRecord from "@/components/orderManagement/sourceRecord.vue";
// import modOnlineOrderData from "@/components/modOnlineOrderData.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "modOrderRecord",
  data() {
    return {
      modStatus: false,
      modData: [
        // {
        // prd_unit: "",
        // MkPgmID: "",
        // startTime: "",
        // detailData: []
        // endTime: "",
        // userCode: ""
        // }
      ],
      workID: "",
      processSelected: null,
      processID: null,
      workorderItem: [],
      wireItem: [],
      runcardItem: [],
      totalProduceTimeItem: [],
      userSelectCode: 0,
      sourceData: [],
      // sourceData: [
      //   {
      //     unit_actual_weight: 100,
      //     workorderItem: [],
      //     wireItem: [
      //       {
      //         index: "",
      //         scroll_no: "test001",
      //         code: "test001",
      //         chinese_name: "test001",
      //         furnaceCode: "test001",
      //         consumption: "test001",
      //         del: ""
      //       },
      //       {
      //         index: "",
      //         scroll_no: "test002",
      //         code: "test002",
      //         chinese_name: "test002",
      //         furnaceCode: "test002",
      //         consumption: "test002",
      //         del: ""
      //       },
      //       {
      //         index: "",
      //         scroll_no: "",
      //         code: "",
      //         chinese_name: "",
      //         furnaceCode: "",
      //         consumption: "",
      //         del: ""
      //       }
      //     ],
      //     runcardItem: [
      //       {
      //         index: "",
      //         runcard_code: "test001",
      //         furnace_code: "test001",
      //         screw_weight: "test001",
      //         bucket_weight: "test001",
      //         del: ""
      //       },
      //       {
      //         index: "",
      //         runcard_code: "test002",
      //         furnace_code: "test002",
      //         screw_weight: "test002",
      //         bucket_weight: "test002",
      //         del: ""
      //       },
      //       {
      //         index: "",
      //         runcard_code: "",
      //         furnace_code: "",
      //         screw_weight: "",
      //         bucket_weight: "",
      //         del: ""
      //       }
      //     ],
      //     totalProduceTimeItem: [
      //       {
      //         code: "",
      //         device_name: "B52",
      //         startTime: "-",
      //         endTime: "-",
      //         totalTime: "-"
      //       }
      //     ]
      //   }
      // ],
      changeUser: "",
      changeUserName: ""
    };
  },
  created: function() {},
  mounted: function() {
    let vm = this;
    vm.changeUser = vm.loginData.account;
    vm.changeUserName = vm.loginData.username;
  },
  components: {
    commonWorkorderTable,
    sourceRecord
  },
  watch: {},
  computed: {
    ...mapGetters({
      axiosResult: "commonaxios/get_axiosResult",
      loginData: "getlogin/get_loginData",
      selectPage: "getlogin/get_selectPage",
      orgProcessOption: "commonqueryiot/get_orgProcessOption"
    })
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_alertMsg: "alertmodal/set_alertMsg",
      settimeout_alertModal: "alertmodal/settimeout_alertModal",
      trigger_loadScreenModal: "loadscreenmodal/trigger_loadScreenModal"
    }),
    queryFoolproof() {
      let vm = this;
      let workID = vm.workID;
      let processSelected = vm.processSelected;
      if (workID == "" || workID == null) {
        vm.set_alertMsg("請輸入派工單號");
        vm.settimeout_alertModal();
        return;
      }
      if (processSelected == "" || processSelected == null) {
        vm.set_alertMsg("請選擇製程");
        vm.settimeout_alertModal();
        return;
      }
      vm.reset(["changeUser", "changeUserName", "workID", "processSelected"]);
      vm.queryOrder(workID, processSelected);
    },
    queryOrder(workID, processSelected) {
      let vm = this;
      vm.trigger_loadScreenModal();
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["workID"] = workID;
      params["processSelected"] = processSelected;
      params["whichFunction"] = "queryOrderData";
      vm.axiosAction(params).then(() => {
        vm.trigger_loadScreenModal();
        var result = vm.axiosResult;
        console.log(result.QueryTableData);
        if (result["Response"] == "ok") {
          let processID = result.QueryTableData.processSelected;
          let workorderItem = result.QueryTableData.workorderItem;
          let sourceData = result.QueryTableData.sourceData;
          vm.workorderItem = workorderItem;
          if (processID == 5) {
            sourceData.forEach(data => {
              data.wireItem.push({
                index: "",
                in_scroll_no: "",
                scroll_no: "",
                orgScroll_no: "",
                code: "",
                chinese_name: "",
                furnaceCode: "",
                in_consumption: "",
                consumption: "",
                orgConsumption: "",
                org_code: "",
                reason: [],
                del: ""
              });
              data.runcardItem.push({
                index: "",
                in_runcard_code: "",
                runcard_code: "",
                orgRuncard_code: "",
                in_furnace_code: "",
                furnace_code: "",
                orgFurnace_code: "",
                in_screw_weight: "",
                screw_weight: "",
                orgScrew_weight: "",
                in_bucket_weight: "",
                bucket_weight: "",
                orgBucket_weight: "",
                reason: [],
                del: ""
              });
            });
          } else if (processID == 6) {
            sourceData.forEach(data => {
              data.runcardItem.push({
                index: "",
                in_runcard_code: "",
                runcard_code: "",
                orgRuncard_code: "",
                in_furnace_code: "",
                furnace_code: "",
                orgFurnace_code: "",
                in_screw_weight: "",
                screw_weight: "",
                orgScrew_weight: "",
                in_bucket_weight: "",
                bucket_weight: "",
                orgBucket_weight: "",
                reason: [],
                del: ""
              });
            });
          } else if (processID == 7) {
            sourceData.forEach(data => {
              data.runcardItem.push({
                index: "",
                in_runcard_code: "",
                runcard_code: "",
                orgRuncard_code: "",
                in_furnace_code: "",
                furnace_code: "",
                orgFurnace_code: "",
                in_screw_weight: "",
                screw_weight: "",
                orgScrew_weight: "",
                in_bucket_weight: "",
                bucket_weight: "",
                orgBucket_weight: "",
                reason: [],
                del: ""
              });
            });
          }
          vm.sourceData = sourceData;
          vm.processID = processID;
          if (sourceData.length == 0) {
            let project_name = "-";
            vm.orgProcessOption.forEach(data => {
              if (data.value == vm.processSelected) {
                project_name = data.text;
                return;
              }
            });
            vm.set_alertMsg(`${workID}在${project_name}製程無完工資料`);
            vm.settimeout_alertModal();
          }
        } else {
          vm.set_alertMsg(result.Response);
          vm.settimeout_alertModal();
        }
      });
    },
    updateRecord() {
      let vm = this;
      if (!vm.modStatus) {
        let workID = vm.workID;
        vm.trigger_loadScreenModal();
        var params = {};
        params["vuePage"] = vm.selectPage;
        params["methods"] = "POST";
        params["workID"] = workID;
        params["whichFunction"] = "checkRecord";
        vm.axiosAction(params).then(() => {
          vm.trigger_loadScreenModal();
          var result = vm.axiosResult;
          if (result["Response"] == "ok") {
            let modData = JSON.parse(JSON.stringify(vm.sourceData));
            vm.modData = modData;
            vm.modStatus = !vm.modStatus;
          } else {
            if (result["Response"] == "online") {
              let project_name = "-";
              if (result.QueryTableData == "R") {
                project_name = "打頭";
              } else if (result.QueryTableData == "W") {
                project_name = "輾牙";
              } else if (result.QueryTableData == "D") {
                project_name = "熱處理";
              }
              vm.set_alertMsg(
                `${workID}正在${project_name}加工中，欲修改資料請待APP結單`
              );
              vm.settimeout_alertModal();
            } else {
              vm.set_alertMsg(result.Response);
              vm.settimeout_alertModal();
            }
          }
        });
      } else {
        let modData = JSON.parse(JSON.stringify(vm.sourceData));
        vm.modData = modData;
        vm.modStatus = !vm.modStatus;
      }
    },
    checkUpdate() {
      let vm = this;
      console.log(vm.sourceData);
      console.log(vm.modData);
      if (JSON.stringify(vm.sourceData) === JSON.stringify(vm.modData)) {
        vm.set_alertMsg("製令無異動，請重新確認");
        vm.settimeout_alertModal();
        console.log("製令無異動，請重新確認");
        vm.modStatus = !vm.modStatus;
        return;
      }
      // 生產單位/製程/時間/數量/人員異動
      let updateData = [];
      let erro = false;
      vm.modData.forEach((data, mainIndex) => {
        data.reasonData = "";
        let wireItem = [];
        console.log(data.wireItem);
        if (data.wireItem != undefined) {
          data.wireItem.forEach((wireItemData, index) => {
            if (index == data.wireItem.length - 1) {
              return;
            }
            if (wireItemData.scroll_no == "") {
              erro = true;
              vm.set_alertMsg("線材捲號尚未輸入");
              vm.settimeout_alertModal();
              return;
            }
            if (wireItemData.consumption == "") {
              erro = true;
              vm.set_alertMsg("耗用量尚未輸入");
              vm.settimeout_alertModal();
              return;
            }
            if (wireItemData.reason.length != 0) {
              if (!data.reasonData.includes("線材資料")) {
                data.reasonData += "線材資料/";
              }
            }
            wireItem.push({
              scroll_no: wireItemData.scroll_no,
              code: wireItemData.code,
              chinese_name: wireItemData.chinese_name,
              furnaceCode: wireItemData.furnaceCode,
              consumption: wireItemData.consumption,
              org_code: wireItemData.org_code
            });
          });
          if (
            data.wireItem.length != vm.sourceData[mainIndex]["wireItem"].length
          ) {
            if (!data.reasonData.includes("線材資料")) {
              data.reasonData += "線材資料/";
            }
          }
          if (erro == true) {
            return;
          }
        }

        if (data.unit_actual_weight != undefined) {
          if (data.unit_actual_weight == "") {
            erro = true;
            vm.set_alertMsg("單支重尚未輸入");
            vm.settimeout_alertModal();
            return;
          }
        }
        if (data.reason.length != 0) {
          if (!data.reasonData.includes("單支重")) {
            data.reasonData += "單支重/";
          }
        }

        let runcardItem = [];
        console.log(data.runcardItem);
        if (data.runcardItem != undefined) {
          data.runcardItem.forEach((runcardItemData, index) => {
            if (index == data.runcardItem.length - 1) {
              return;
            }
            if (runcardItemData.runcard_code == "") {
              erro = true;
              vm.set_alertMsg("流程卡號尚未輸入");
              vm.settimeout_alertModal();
              return;
            }
            if (runcardItemData.furnace_code == "") {
              erro = true;
              vm.set_alertMsg("爐號尚未輸入");
              vm.settimeout_alertModal();
              return;
            }
            if (runcardItemData.screw_weight == "") {
              erro = true;
              vm.set_alertMsg("重量尚未輸入");
              vm.settimeout_alertModal();
              return;
            }
            if (runcardItemData.bucket_weight == "") {
              erro = true;
              vm.set_alertMsg("桶重尚未輸入");
              vm.settimeout_alertModal();
              return;
            }
            if (runcardItemData.reason.length != 0) {
              if (!data.reasonData.includes("生產重量")) {
                data.reasonData += "生產重量/";
              }
            }
            runcardItem.push({
              runcard_code: runcardItemData.runcard_code,
              furnace_code: runcardItemData.furnace_code,
              screw_weight: runcardItemData.screw_weight,
              bucket_weight: runcardItemData.bucket_weight
            });
          });
          if (
            data.runcardItem.length !=
            vm.sourceData[mainIndex]["runcardItem"].length
          ) {
            if (!data.reasonData.includes("生產重量")) {
              data.reasonData += "生產重量/";
            }
          }
          if (erro == true) {
            return;
          }
        }

        let totalProduceTimeItem = [];
        data.totalProduceTimeItem.forEach(totalProduceTimeItemData => {
          if (totalProduceTimeItemData.device_name == "") {
            erro = true;
            vm.set_alertMsg("機台編號尚未輸入");
            vm.settimeout_alertModal();
            return;
          }
          if (totalProduceTimeItemData.reason.length != 0) {
            if (!data.reasonData.includes("生產機台")) {
              data.reasonData += "生產機台/";
            }
          }
          totalProduceTimeItem.push({
            code: totalProduceTimeItemData.code,
            device_name: totalProduceTimeItemData.device_name,
            startTime: totalProduceTimeItemData.startTime,
            endTime: totalProduceTimeItemData.endTime,
            totalTime: totalProduceTimeItemData.totalTime
          });
        });
        if (erro == true) {
          return;
        }

        if (data.reasonData != "") {
          data.reasonData = data.reasonData.substring(
            0,
            data.reasonData.length - 1
          );
          data.reasonData += "異動";

          updateData.push({
            workorderBind: data.workorderBind,
            wireItem: wireItem,
            unit_actual_weight: data.unit_actual_weight,
            runcardItem: runcardItem,
            totalProduceTimeItem: totalProduceTimeItem,
            reason: data.reason,
            reasonData: data.reasonData
          });
        }
      });

      if (erro == true) {
        return;
      }

      if (updateData.length == 0) {
        vm.set_alertMsg("製令無異動，請重新確認");
        vm.settimeout_alertModal();
        console.log("製令無異動，請重新確認");
        vm.modStatus = !vm.modStatus;
        return;
      }

      console.log(updateData);
      console.log("有異動");
      vm.trigger_loadScreenModal();
      var params = {};
      params["vuePage"] = vm.selectPage;
      params["methods"] = "POST";
      params["data"] = updateData;
      params["changeUser"] = vm.changeUser;
      params["whichFunction"] = "updateCompleteOrder";
      vm.axiosAction(params).then(() => {
        vm.trigger_loadScreenModal();
        var result = vm.axiosResult;
        if (result["Response"] == "ok") {
          let workID = result.QueryTableData.work_code;
          let processSelected = result.QueryTableData.project_id;
          vm.queryOrder(workID, processSelected);
          vm.modStatus = !vm.modStatus;
        } else {
          vm.set_alertMsg(`異常，請再次確認`);
          vm.settimeout_alertModal();
          return;
        }
      });
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    }
  },
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss">
.records-button {
  height: 2rem;
  line-height: 2rem;
  padding: 0px;
  width: 4.25rem;
}
.records-button.active {
  background-color: #4b8c80 !important;
  border-color: #4b8c80 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/modOrderRecord.vue